import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/components/base.component';
import { BaseService } from 'src/app/services/base.service';
import { SharedService } from 'src/app/services/sharedService';

@Component({
  selector: 'rdf-block-view',
  templateUrl: './block-view.component.html',
  styleUrls: ['./block-view.component.css']
})
export class BlockViewComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() block;
  @Input() emittables;
  stageRowKeys = []
  constructor(private sharedService: SharedService) {
    super()
  }

  ngOnInit() {
    this.sharedService.stageRowKeysSubject$.pipe(takeUntil(this.destroy$)).subscribe(rowKeys => {
      this.stageRowKeys = rowKeys
    })
  }

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }

}
